import { useEffect } from 'react'

const useVisibilityDetection = ({ showSuggestions, setShowSuggestions, containerRef }) => {
  // Use IntersectionObserver for efficient visibility detection
  useEffect(() => {
    if (!showSuggestions || !containerRef.current) { return }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        if (!entry.isIntersecting && showSuggestions) {
          setShowSuggestions(false)
        }
      },
      {
        root: null, // Use viewport as root
        rootMargin: '0px',
        threshold: 0.1, // Trigger when 10% of element is visible
      }
    )

    // Observe the container element
    observer.observe(containerRef.current)

    // Also handle document visibility changes (tab switching)
    const handleVisibilityChange = () => {
      if (document.hidden && showSuggestions) {
        setShowSuggestions(false)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      observer.disconnect()
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [showSuggestions, setShowSuggestions, containerRef])
}

export default useVisibilityDetection
